export default __webpack_public_path__ + "static/media/banh-chung.dfd5d318.jpg";